var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "newNavBarContainer", attrs: { id: "newNavBarContainer" } },
    [
      _c("div", { staticClass: "newNavbar" }, [
        _c(
          "div",
          { staticClass: "newNavbarBox" },
          [
            _c(
              "el-badge",
              {
                attrs: {
                  hidden: _vm.messageNumber == 0,
                  value: _vm.messageNumber,
                },
              },
              [
                _c("div", {
                  staticClass: "message",
                  on: {
                    click: function ($event) {
                      return _vm.openMessageDialog()
                    },
                  },
                }),
              ]
            ),
            _c(
              "div",
              { staticClass: "user_box" },
              [
                _c("router-link", { attrs: { to: "/organization" } }, [
                  _c(
                    "div",
                    {
                      staticStyle: { display: "flex", "align-items": "center" },
                    },
                    [
                      _c("span", { staticClass: "nick_name" }, [
                        _vm._v(_vm._s(_vm.$store.state.userInfor.name)),
                      ]),
                      _c("i", { staticClass: "el-icon-arrow-down" }),
                    ]
                  ),
                ]),
                _c("div", { staticClass: "hidden_box" }, [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticStyle: { display: "flex" } },
                        [
                          _c(
                            "router-link",
                            { attrs: { to: "/organization" } },
                            [
                              _c("div", { staticClass: "avatar" }, [
                                _c("img", {
                                  staticStyle: { "border-radius": "50%" },
                                  attrs: {
                                    src: _vm.$store.state.userInfor.imageUrl,
                                    alt: "",
                                    height: "100%",
                                    width: "100%",
                                  },
                                }),
                              ]),
                            ]
                          ),
                          _vm._m(0),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "quitLogin",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.quitLogin()
                            },
                          },
                        },
                        [_vm._v("退出")]
                      ),
                    ]
                  ),
                ]),
              ],
              1
            ),
            _vm._m(1),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "navbar" }, [
        _c("div", { staticClass: "mune" }, [
          _c("div", { staticClass: "logo" }),
          _c(
            "div",
            {
              class:
                _vm.$store.state.checkedIndex == 0
                  ? "mune_item isChecked"
                  : "mune_item",
              on: {
                click: function ($event) {
                  return _vm.arriveAt(0)
                },
              },
            },
            [_c("span", [_vm._v("首页")])]
          ),
          _c(
            "div",
            {
              class:
                _vm.$store.state.checkedIndex == 1
                  ? "inquiry_box isChecked"
                  : "inquiry_box",
            },
            [
              _vm._m(2),
              _c("i", {
                staticClass: "el-icon-caret-top dangban",
                staticStyle: {
                  color: "white",
                  position: "absolute",
                  bottom: "-3px",
                  left: "50%",
                },
              }),
              _c(
                "div",
                {
                  staticClass: "inquiry_mune",
                  staticStyle: { width: "2.9rem" },
                },
                [
                  _c("div", [
                    _c("div", [
                      _c(
                        "span",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.arriveAt(1, 1)
                            },
                          },
                        },
                        [_vm._v("整团询价")]
                      ),
                      _c("b"),
                      _c(
                        "span",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.arriveAt(1, 2)
                            },
                          },
                        },
                        [_vm._v("项目询价")]
                      ),
                      _c("b"),
                      _c(
                        "span",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.arriveAt(1, 3)
                            },
                          },
                        },
                        [_vm._v("我的询价")]
                      ),
                    ]),
                  ]),
                ]
              ),
            ]
          ),
          _c(
            "div",
            {
              class:
                _vm.$store.state.checkedIndex == 2
                  ? "inquiry_box isChecked"
                  : "inquiry_box",
              on: {
                click: function ($event) {
                  return _vm.arriveAt(2)
                },
              },
            },
            [
              _vm._m(3),
              _c("i", {
                staticClass: "el-icon-caret-top dangban",
                staticStyle: {
                  color: "white",
                  position: "absolute",
                  bottom: "-3px",
                  left: "50%",
                },
              }),
              _c(
                "div",
                {
                  staticClass: "inquiry_mune",
                  staticStyle: { width: "3.5rem" },
                },
                [
                  _c("div", { staticStyle: { display: "flex" } }, [
                    _c(
                      "span",
                      {
                        staticStyle: { flex: "1", "text-align": "center" },
                        on: {
                          click: function ($event) {
                            return _vm.arriveAt(2, 1)
                          },
                        },
                      },
                      [_vm._v("抢单池")]
                    ),
                    _c("b"),
                    _c(
                      "span",
                      {
                        staticStyle: { flex: "2", "text-align": "center" },
                        on: {
                          click: function ($event) {
                            return _vm.arriveAt(2, 2)
                          },
                        },
                      },
                      [_vm._v("我抢到的整团询单")]
                    ),
                    _c("b"),
                    _c(
                      "span",
                      {
                        staticStyle: { flex: "2", "text-align": "center" },
                        on: {
                          click: function ($event) {
                            return _vm.arriveAt(2, 3)
                          },
                        },
                      },
                      [_vm._v("我抢到的单项询单")]
                    ),
                  ]),
                ]
              ),
            ]
          ),
          _c(
            "div",
            {
              class:
                _vm.$store.state.checkedIndex == 3
                  ? "inquiry_box isChecked"
                  : "inquiry_box",
              on: {
                click: function ($event) {
                  return _vm.arriveAt(3, 2)
                },
              },
            },
            [
              _vm._m(4),
              _c("i", {
                staticClass: "el-icon-caret-top dangban",
                staticStyle: {
                  color: "white",
                  position: "absolute",
                  bottom: "-3px",
                  left: "50%",
                },
              }),
              _c(
                "div",
                {
                  staticClass: "inquiry_mune",
                  staticStyle: { width: "3.2rem" },
                },
                [
                  _c("div", { staticStyle: { display: "flex" } }, [
                    _c(
                      "span",
                      {
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.arriveAt(3, 1)
                          },
                        },
                      },
                      [_vm._v("创建方案")]
                    ),
                    _c("b", {
                      staticStyle: {
                        height: "20px",
                        "border-right": "1px solid #ddd",
                      },
                    }),
                    _c(
                      "span",
                      {
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.arriveAt(3, 2)
                          },
                        },
                      },
                      [_vm._v("我的方案")]
                    ),
                    _c("b", {
                      staticStyle: {
                        height: "20px",
                        "border-right": "1px solid #ddd",
                      },
                    }),
                    _c(
                      "span",
                      {
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.arriveAt(3, 3)
                          },
                        },
                      },
                      [_vm._v("方案库")]
                    ),
                    _c("b", {
                      staticStyle: {
                        height: "20px",
                        "border-right": "1px solid #ddd",
                      },
                    }),
                    _c(
                      "span",
                      {
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.arriveAt(3, 4)
                          },
                        },
                      },
                      [_vm._v("回收站")]
                    ),
                  ]),
                ]
              ),
            ]
          ),
          _c(
            "div",
            {
              class:
                _vm.$store.state.checkedIndex == 4
                  ? "inquiry_box isChecked"
                  : "inquiry_box",
            },
            [
              _c("div", [
                _c(
                  "span",
                  {
                    on: {
                      click: function ($event) {
                        return _vm.arriveAt(4)
                      },
                    },
                  },
                  [_vm._v("订单")]
                ),
                _c("i", {
                  staticClass: "el-icon-arrow-down",
                  staticStyle: { "margin-left": "5px", "font-size": "12px" },
                }),
              ]),
              _c("i", {
                staticClass: "el-icon-caret-top dangban",
                staticStyle: {
                  color: "white",
                  position: "absolute",
                  bottom: "-3px",
                  left: "50%",
                },
              }),
              _c(
                "div",
                { staticClass: "inquiry_mune", staticStyle: { width: "2rem" } },
                [
                  _c("div", { staticStyle: { display: "flex" } }, [
                    _c(
                      "span",
                      {
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.arriveAt(4, 1)
                          },
                        },
                      },
                      [_vm._v("表格形式")]
                    ),
                    _c("b", {
                      staticStyle: {
                        height: "20px",
                        "border-right": "1px solid #ddd",
                      },
                    }),
                    _c(
                      "span",
                      {
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.arriveAt(4, 2)
                          },
                        },
                      },
                      [_vm._v("行程轴形式")]
                    ),
                  ]),
                ]
              ),
            ]
          ),
          _c(
            "div",
            {
              class:
                _vm.$store.state.checkedIndex == 5
                  ? "mune_item isChecked"
                  : "mune_item",
              on: {
                click: function ($event) {
                  return _vm.arriveAt(5)
                },
              },
            },
            [_c("span", [_vm._v("钱包")])]
          ),
          _c(
            "div",
            {
              class:
                _vm.$store.state.checkedIndex == 6
                  ? "mune_item isChecked"
                  : "mune_item",
              on: {
                click: function ($event) {
                  return _vm.arriveAt(6)
                },
              },
            },
            [_c("span", [_vm._v("客户")])]
          ),
          _c("audio", { attrs: { id: "bgMusic" } }),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "main-content" },
        [_c("router-view", { ref: "childVue" })],
        1
      ),
      _c("create-plan", { ref: "createPlan" }),
      _vm.isShow
        ? _c("MessageCenterPopUpBox", {
            ref: "messageCenterPopUpBox",
            on: {
              refreshNumber: _vm.getMessageNumber,
              messageCenterClose: function ($event) {
                _vm.isShow = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "box_right" }, [
      _c("div", [
        _vm._v(" 积分："),
        _c("span", { staticStyle: { color: "#dd5827" } }),
      ]),
      _c("div", { staticStyle: { "margin-top": "10px" } }, [_vm._v("会员")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "lainxi" }, [
      _c("span", [_vm._v("联系客服")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("span", [_vm._v("询价")]),
      _c("i", {
        staticClass: "el-icon-arrow-down",
        staticStyle: { "margin-left": "5px", "font-size": "12px" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("span", [_vm._v("抢单")]),
      _c("i", {
        staticClass: "el-icon-arrow-down",
        staticStyle: { "margin-left": "5px", "font-size": "12px" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("span", [_vm._v("方案")]),
      _c("i", {
        staticClass: "el-icon-arrow-down",
        staticStyle: { "margin-left": "5px", "font-size": "12px" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }